import { BaseLayout, GetLayout } from '@scorenco/next';

import { ScreenLayoutComponent } from './ScreenLayoutComponent';

const getLayout: GetLayout = (page) => (
  <ScreenLayoutComponent>{page}</ScreenLayoutComponent>
);

export const buildGetLayout: typeof BaseLayout.buildGetLayout = (
  getLayouts = []
) => {
  return BaseLayout.buildGetLayout([getLayout, ...getLayouts]);
};
